import React, { useEffect, useState } from "react";
import { Button, Form, FormGroup, Label, Table } from "reactstrap";
import { CSVLink } from "react-csv";
import Select from "react-select";
import moment from "moment";

const fileName = "BiddEasy_Portfolio_Timeline_" + 
  new Date().getDate() + "" +
  (new Date().getMonth() + 1) + "" +
  new Date().getFullYear();

  const options = [
    { value: 'purchase', label: 'Purchase' },
    { value: 'redeem', label: 'Redeem' },
    { value: 'sell', label: 'Sell' },
    // Add more options as needed
  ];
export default function ObRecentTransaction(props) {
  const [uncollapsed, setUncollapsed] = useState([]);
  const [selectedOption,setSelectedOption] = useState (null);

  useEffect(() => {
    if (props.transaction && props.transaction.length > 3) {
      setUncollapsed([...props.transaction.slice(0, 3)]);
    } else {
      setUncollapsed([...props.transaction]);
    }
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  }

  const styles={
    border: "1px solid black",
    width: "20%",
    marginBottom: "19px"
  }

  const csvBtn = {
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    width: "auto",
    padding: "0.5rem",
    verticalAlign: "center"
  }

  const showMoreTx = () => {
    setUncollapsed([...props.transaction]);
  };

  const showLessTx = () => {
    setUncollapsed([...props.transaction.slice(0, 3)]);
  };

  const getOrderStatus = (status) => {
    if (status === "Order Initiated" || status === "Quote Requested" || status === "Order Placed" || status === "Order Under Process"
    || status === "Bid pending" || status === "Bid placed") {
      return "text-warning";
    }
    if (status === "Order Processed" ||
     status === "Payment Received" || status === "Bid success" ||
     status === "Mandate accepted" || status === "Units alloted") {
      return "text-success";
    }
    return "text-danger";
  };

  const downloadTxn = (obTxns) => {
    var csvData = [];
    var columns = [
      "Date",
      "Instrument",
      "Amount",
      "Type",
      "Status",
    ];
    csvData.push(columns);
    if (props.transaction && props.transaction.length) {
      for (let txn of obTxns) {
        var values = [];
        values.push(txn && txn?.amountBreakup?.tradeDate ?
          new moment(new Date(txn.amountBreakup.tradeDate))
          .format("DD/MM/YYYY") : "--");
        let instrumentOb = props.bonds && 
                           props.bonds.find((e) => e.product === txn.product);
        let instrument = instrumentOb && instrumentOb.productName;
        values.push(instrument && instrument || "--");
        values.push(txn && txn?.amountBreakup?.userAmount || "--");
        values.push(txn && txn?.type || "purchase");
        values.push(txn && txn?.status || "--");
        
        csvData.push(values);
      };
    };
    return csvData;
  };

  const getProductName = (product) => {
    let instrumentOb =
      props.bonds && props.bonds.length &&
      props.bonds.find((e) => e.product === product);

      instrumentOb = instrumentOb?.displayName;
    return instrumentOb;
  }
  
  return (
    <div className="recent-tx">
      <div className="d-flex justify-content-between">
      <p className="font-weight-semi-bold header">Recent Transactions</p>
        {/* <Form>
          <FormGroup>
            <Select className="select-tx"
            // placeholder="transations"
            value={selectedOption}
            onChange={handleChange}
            options={options}
            />
          </FormGroup>
        </Form> */}
        {/* Commented code will needed in future to 
        integrate in report section in hamburger.

        SO PLEASE DO NOT REMOVE */}
      {/* { props.transaction && props.transaction.length ?
          (window.ReactNativeWebView ? (
            <div
              style={csvBtn}
              className="btn font-size-tiny text-secondary mt-3"
              onClick={() => {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    fileName:fileName,
                    action: "DOWNLOAD_CSV",
                    data: downloadTxn(props.transaction && props.transaction),
                  })
                );
              }}
            >
              <i
                className="mdi mdi-download font-size-small"
                style={{ position: "relative", "line-height": "0" }}
              />
              <p className="mt-1">Download Timeline</p>
            </div>
          ) : (
            <CSVLink
              style={csvBtn}
              filename={fileName}
              data={downloadTxn(props.transaction && props.transaction)}
              className="btn font-size-tiny text-secondary mt-3" // margin req for mobile view
            >
              <i
                className="mdi mdi-download font-size-small"
                style={{ position: "relative", "line-height": "0" }}
              />
              <p className="mt-1">Download Timeline</p>
            </CSVLink>
          )) : ""
        } */}
        </div>
      <div className="table-wrapper">
        <Table striped bordered className="trans-table">
          <thead className="thead">
            <tr>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Date-Time
              </th>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Product Name
              </th>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Transaction Type
              </th>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Status
              </th>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Amount
              </th>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Units
              </th>
              <th className="text-center bg-primary text-white font-weight-semi-bold noBorder">
                Transaction Id
              </th> 
            </tr>
          </thead>
          <tbody className="tbodyStyle">
            {uncollapsed &&
              uncollapsed.length &&
              uncollapsed.map((item) => {
                return (
                  <tr className="text-center">
                    <td className="text-capitalize noBorder">
                    {moment(item?.createdAt*1000).format('DD/MM/YYYY')} - {moment(item?.createdAt*1000).format('h:mm:ss A')}                   
                    </td>
                    <td className="text-capitalize noBorder">
                       {getProductName(item.product)}
                    </td>
                    <td className="text-capitalize noBorder">
                    {item?.type || "Purchase"}
                    </td>
                    <td
                      className={
                        "font-weight-semi-bold text-capitalize " +
                        getOrderStatus(item?.status)
                      }
                    >
                      {item?.status === "Quote Ready" ? 
                      <a className="text-success" href={`/platform/#/biddeasy-asset/${item.productType}/${item.product}/redeem/${item.orderId}`}><u>{item.status}</u> 
                      </a> : item.status}
                    </td>
                    <td className="text-capitalize noBorder">
                      {item?.status === "Quote Ready" || item.status === "Quote Requested" || item.status === "Order Cancelled" ? "--" : item?.amountBreakup?.ispAmount ? 
                      (item?.amountBreakup?.ispAmount).oroNumber(2, true) 
                      :(item?.amountBreakup?.userAmount).oroNumber(2, true)}
                    </td>
                    <td className="text-capitalize noBorder">
                    {item?.productType === "ipo" ? item.amountBreakup.units : item?.units ? item.units : "--"}
                    </td>
                    <td className="noBorder">
                      {item?.orderId}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
      {uncollapsed && uncollapsed.length === 3 ? (
        <div className="text-center">
          <Button outline 
            color="secondary"
            className="view-btn"
            onClick={showMoreTx}>
            View More
            <i className="mdi mdi-arrow-down-drop-circle-outline" />
          </Button>
        </div>
      ) : (
        ""
      )}
      {uncollapsed && uncollapsed.length > 3 ? (
        <div className="text-center">
          <Button outline 
            color="secondary"
            className="text-center view-btn"
            onClick={showLessTx}>
              View Less
              <i className="mdi mdi-arrow-up-drop-circle-outline" />
          </Button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
